import goldBurn from "../../assets/images/sweeps/burn/gold.jpg";
import sweepsBurn from "../../assets/images/sweeps/burn/sweeps.jpg";
import PageBackground from '../../components/Layouts/PageBackground';
import "./Burn.css";

const Burn = () => {
    return (
        <PageBackground title="Burn">
            <div className="b2b-uoter-box">
                <div className="gradient-box-text-holder">
                    <div className="b2b-scroll-box">
                        <p>Below is the burn structure for Ring games on SOPO:</p>
                        <br />
                        <div className="burn-box">
                            <div className="burn-box-left">
                                <p>
                                    <u>Gold</u>
                                </p>
                                <img src={goldBurn} alt="jackpot odds" draggable="false" />
                            </div>
                            <div className="burn-box-right">
                                <p>
                                    <u>Sweeps Coins</u>
                                </p>
                                <img src={sweepsBurn} alt="jackpot odds" draggable="false" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PageBackground>
    );
}

export default Burn
